import { Action } from '@ngrx/store';

export const GET_CAR_CATEGORIES = '[Car Categories] Get car categories';
export const GET_CAR_CATEGORIES_SUCCESS = '[Car Categories] Get car categories success';

export class GetCarCategories implements Action {
  readonly type = GET_CAR_CATEGORIES;
}

export class GetCarCategoriesSuccess implements Action {
  readonly type = GET_CAR_CATEGORIES_SUCCESS;
  constructor(public payload: any) {}
}

export type CarCategoriesActions = GetCarCategories | GetCarCategoriesSuccess;
